import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'
import type { GridCardProps } from '@/types/general'
import { TileIcon } from './shared/TileIcon'

export function FileFormatCard({ icon, title }: GridCardProps) {
	return (
		<div className="flex flex-col lg:pt-10 lg:pb-5 lg:gap-10 pb-4 pt-8 gap-8 justify-center">
			{icon && <TileIcon icon={icon} size="large" className="items-center" />}
			{title && (
				<div className="flex flex-col items-center text-center">
					<Heading
						tag="h3"
						fontSize="headingMedium"
						className={cn(
							'font-bold text-center group-data-[state=active]:text-brand-salmon group-hover:text-brand-salmon transition-colors ',
						)}
					>
						{title}
					</Heading>
				</div>
			)}
		</div>
	)
}
